export interface LyricLine { atMs: number | null; text: string }
export function adjustedLyricsPositionMs(positionMs: number, offsetSeconds = 1): number {
  const safeOffset = Math.max(-2, Math.min(2, offsetSeconds));
  return Math.max(0, positionMs + safeOffset * 1_000);
}

export function parseLyrics(value: string): LyricLine[] {
  const lines: LyricLine[] = [];
  for (const source of value.split(/\r?\n/)) {
    const matches = [...source.matchAll(/\[(\d{1,3}):(\d{2})(?:\.(\d{1,3}))?\]/g)];
    const text = source.replace(/\[[^\]]+\]/g, "").trim(); if (!text) continue;
    if (!matches.length) { lines.push({ atMs: null, text }); continue; }
    for (const match of matches) { const fraction = (match[3] ?? "0").padEnd(3, "0").slice(0, 3); lines.push({ atMs: Number(match[1]) * 60_000 + Number(match[2]) * 1_000 + Number(fraction), text }); }
  }
  return lines.sort((a, b) => (a.atMs ?? Number.MAX_SAFE_INTEGER) - (b.atMs ?? Number.MAX_SAFE_INTEGER));
}
